import { NavLink } from 'react-router-dom';
import { GridIcon, PackageIcon, OrdersIcon, UserIcon, TagIcon } from './icons';
import { useAuthContext } from '../../context/AuthProvider';

const enlaces = [
  { to: '/admin', label: 'Dashboard', Icon: GridIcon, soloAdministrador: false, exact: true },
  { to: '/admin/catalogo', label: 'Catálogo', Icon: PackageIcon, soloAdministrador: false, exact: false },
  { to: '/admin/categorias', label: 'Categorías', Icon: TagIcon, soloAdministrador: false, exact: false },
  { to: '/admin/pedidos', label: 'Pedidos', Icon: OrdersIcon, soloAdministrador: false, exact: false },
  { to: '/admin/cuentas', label: 'Cuentas', Icon: UserIcon, soloAdministrador: true, exact: false },
];

interface Props {
  /** En mobile el sidebar es un drawer off-canvas — en md+ siempre esta visible. */
  abierto: boolean;
  onCerrar: () => void;
}

export function AdminSidebar({ abierto, onCerrar }: Props) {
  const { sesion } = useAuthContext();

  return (
    <>
      {abierto && (
        <div
          className="fixed inset-0 bg-ink/40 z-30 md:hidden"
          onClick={onCerrar}
          aria-hidden="true"
        />
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-40 w-60 shrink-0 bg-wood-dark flex flex-col py-6 transition-transform duration-200 md:static md:translate-x-0 ${
          abierto ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="font-display text-2xl font-bold text-white px-6 pb-7">Santtesanía</div>
        <nav className="flex flex-col gap-0.5">
          {enlaces
            .filter((e) => !e.soloAdministrador || sesion?.rol === 'Administrador')
            .map(({ to, label, Icon, exact }) => (
              <NavLink
                key={to}
                to={to}
                end={exact}
                onClick={onCerrar}
                data-testid={`admin-nav-${label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-6 py-3 text-sm font-medium ${
                    isActive
                      ? 'bg-wood border-l-[3px] border-gold text-white font-semibold pl-[21px]'
                      : 'text-border/80 hover:text-white'
                  }`
                }
              >
                <Icon width={17} height={17} />
                {label}
              </NavLink>
            ))}
        </nav>
      </aside>
    </>
  );
}
